// This is used externally by the whiteboard package to load the SVG icons asynchronously.
export const loadMonacoEditor = async () => {
  // Dyanamically import the editor.
  const { default: loadMonacoEditor } = await import(
    /* webpackChunkName: "monaco-editor" */ './monaco-editor-sync'
  );

  return loadMonacoEditor;
};
